import './ImageLinkWithSpanAndTitle.scss';
import React from 'react';
import Link from 'gatsby-link';
import { Controls } from '../../../helpers/services/controls';

const componentInfo = {
  name: 'ImageLinkWithSpanAndTitle',
  className: 'image-link-with-span-and-title',
  useType: 'ContentPiece',
  componentType: 'Basic',
};
const ImageLinkWithSpanAndTitle = ({
  title,
  imageLink,
  spanContent,
  redirectLink,
  onClick,
}: {
  title: string;
  imageLink: string;
  spanContent: string;
  redirectLink: string;
  onClick: () => {};
}) => (
  <Link className={componentInfo.className} onClick={onClick} to={redirectLink}>
    <div>
      <img src={imageLink}></img>
      {Controls.IsStringEmptyNullOrUndefined(spanContent) ? <></> : <span>{spanContent}</span>}
    </div>
    <div>{title}</div>
  </Link>
);

export default ImageLinkWithSpanAndTitle;
